export const environment = {
  production: true,
  backgroundCssVariable: 'bg-gradient-uat',
  topBarCssVariable: 'top-bar-uat',
  apiUrl: 'https://portalapi-uat.acs-sa.com'
  //apiUrl: 'https://localhost:44380'

  //production: true,
  //backgroundCssVariable: '',
  //topBarCssVariable: '',
  //apiUrl: 'https://portalapi.acs-sa.com',
};

